import { render, staticRenderFns } from "./GridProductItem.vue?vue&type=template&id=3bf216fa&"
import script from "./GridProductItem.vue?vue&type=script&lang=js&"
export * from "./GridProductItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports